// extracted by mini-css-extract-plugin
export var searchHeader = "_ac-0";
export var searchHeaderDark = "_ac-1";